import { useCallback, useState } from "react";
import { useSaveDownloaded } from "./useSaveDownloaded";

export const useExportExcel = (
  service: any,
  request: any,
  name: string,
  onSuccess?: () => void,
) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { save } = useSaveDownloaded(
    name,
    "application/octet-stream",
    setIsLoading,
  );

  const onExportExcelButtonClicked = useCallback((): void => {
    setIsLoading(true);
    service
      .getExcel(request)
      .then((res: any) => {
        save(res);
        onSuccess && onSuccess();
      })
      .catch(() => setIsLoading(false));
  }, [service, request, save, onSuccess]);

  return { onExportExcelButtonClicked, isLoading };
};
